var _excluded = ["stepNumber", "title", "isActive", "isVertical", "isLast", "onStepClick", "disabled", "activeStep"],
    _excluded2 = ["activeStep", "steps", "vertical", "onStepClick"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo, useCallback } from 'react';
import { Div, Span } from '@kizi/core-components';
export var Step = function Step(_ref) {
  var stepNumber = _ref.stepNumber,
      title = _ref.title,
      isActive = _ref.isActive,
      isVertical = _ref.isVertical,
      isLast = _ref.isLast,
      onStepClick = _ref.onStepClick,
      disabled = _ref.disabled,
      activeStep = _ref.activeStep,
      divProps = _objectWithoutProperties(_ref, _excluded);

  var titleDisplay = isActive ? 'block' : ['none', 'none', 'none', 'block'];
  var stepVariant = isActive ? 'steps.active' : 'steps.inactive';
  var titleVariant = isActive ? 'steps.activeText' : 'steps.inactiveText';
  var onClickHandler = useCallback(function () {
    if (onStepClick) onStepClick(stepNumber);
  }, [onStepClick]);
  var showPointerCursor = stepNumber < activeStep + 1 && !disabled;
  return /*#__PURE__*/React.createElement(Div, _extends({}, divProps, {
    style: {
      cursor: showPointerCursor ? 'pointer' : 'text'
    }
  }), /*#__PURE__*/React.createElement(Div, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Div, {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    variant: stepVariant,
    onClick: onClickHandler
  }, /*#__PURE__*/React.createElement(Span, {
    display: "block",
    variant: "steps.stepNumber"
  }, stepNumber)), /*#__PURE__*/React.createElement(Span, {
    display: titleDisplay,
    variant: titleVariant,
    onClick: onClickHandler
  }, title), !isVertical && !isLast && /*#__PURE__*/React.createElement(Span, {
    display: "inline-block",
    variant: "steps.dash"
  })), isVertical && !isLast && /*#__PURE__*/React.createElement(Span, {
    display: "inline-block",
    variant: "steps.verticalDash"
  }));
};
export var Steps = function Steps(_ref2) {
  var activeStep = _ref2.activeStep,
      steps = _ref2.steps,
      _ref2$vertical = _ref2.vertical,
      vertical = _ref2$vertical === void 0 ? false : _ref2$vertical,
      onStepClick = _ref2.onStepClick,
      divProps = _objectWithoutProperties(_ref2, _excluded2);

  var stepList = useMemo(function () {
    return steps.map(function (step, i) {
      var stepProps = {
        isLast: i === steps.length - 1,
        isVertical: vertical,
        stepNumber: i + 1,
        title: step.title,
        onStepClick: step.onStepClick ? step.onStepClick : onStepClick,
        isActive: activeStep === i,
        disabled: step.disabled || false,
        activeStep: activeStep
      };
      return /*#__PURE__*/React.createElement(Step, _extends({
        key: i
      }, stepProps));
    });
  }, [steps, vertical, onStepClick, activeStep]);
  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    flexDirection: vertical ? 'column' : 'row'
  }, divProps), stepList);
};